import { Button, ButtonActionBar, Typography } from 'modules/core/components'
import { DownloadOutlined } from '@ant-design/icons'
import { sendUserDataToGTM } from 'modules/core/utils'

const TableActions = ({ loggedUser }) => {
  return (
    <ButtonActionBar>
      <Button.Icon
        title="ACTION_DOWNLOAD_TABLE"
        icon={<Typography.Icon icon={DownloadOutlined} />}
        onClick={() => {
          console.log('descargar tabla')
          sendUserDataToGTM(
            loggedUser,
            'Tipo de presupuestos',
            'Descargar tipo de presupuestos',
            'Descarga',
          )
        }}
      />
    </ButtonActionBar>
  )
}

export default TableActions
